import Footer from "./Footer";
import Header from "./Header";
import Main from "./Main";
import { Outlet } from "react-router";
import { Toaster } from "react-hot-toast";
import { ChatProvider } from "../../context/ChatContext";

const MainLayout = () => {
  return (
    <ChatProvider>
      <div className="bg-gray-50 min-h-screen flex flex-col">
        <Toaster position="top-center" />
        <Header />
        <Main children={<Outlet />} />
        <Footer />
      </div>
    </ChatProvider>
  );
};

export default MainLayout;
